import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import Icon from 'components/AppIcon';
import { Link } from 'react-router-dom';

const TrainingDevelopmentServicesPage = () => {
  const trainingServices = [
    {
      icon: "GraduationCap",
      title: "Formation Leadership",
      description: "Développez des leaders inspirants capables de transformer vos équipes et d\'accélérer la performance organisationnelle.",
      features: ["Leadership transformationnel", "Gestion d\'équipes", "Prise de décision stratégique"]
    },
    {
      icon: "Users",
      title: "Développement Compétences",
      description: "Programmes sur mesure pour renforcer les compétences techniques et comportementales de vos collaborateurs.",
      features: ["Compétences techniques", "Soft skills", "Accompagnement personnalisé"]
    },
    {
      icon: "Target",
      title: "Formation Managériale",
      description: "Outillez vos managers pour maximiser l'efficacité, motiver leurs équipes et atteindre les objectifs business.",
      features: ["Management performant", "Communication efficace", "Gestion de conflits"]
    },
    {
      icon: "TrendingUp",
      title: "Transformation Digitale",
      description: "Accompagnez vos équipes dans l'adoption des outils numériques et des nouvelles méthodes de travail agiles.",
      features: ["Outils digitaux", "Agilité organisationnelle", "Innovation continue"]
    }
  ];

  const keyBenefits = [
    {
      icon: 'Award',
      title: 'Formateurs Certifiés',
      description: 'Experts reconnus avec certifications internationales et expérience terrain prouvée.'
    },
    {
      icon: 'Target',
      title: 'Approche Sur Mesure',
      description: 'Programmes adaptés à vos enjeux spécifiques et contexte organisationnel unique.'
    },
    {
      icon: 'TrendingUp',
      title: 'ROI Mesurable',
      description: 'Impact quantifiable avec +35% de productivité et amélioration continue des performances.'
    },
    {
      icon: 'CheckCircle',
      title: 'Suivi Post-Formation',
      description: 'Accompagnement prolongé pour garantir l\'application des acquis et pérenniser les changements.'
    }
  ];

  const successStories = [
    {
      client: "Grande Entreprise Industrielle",
      sector: "Manufacturing",
      challenge: "Besoin urgent de renforcer les compétences managériales de 120 cadres",
      solution: "Programme leadership intensif sur 6 mois avec coaching individuel et ateliers pratiques",
      results: ["+40% engagement équipes", "Turnover réduit de 25%", "Performance +35%"],
      icon: "Factory"
    },
    {
      client: "Institution Bancaire Régionale",
      sector: "Finance",
      challenge: "Transformation digitale nécessitant l\'upskilling de 300 collaborateurs",
      solution: "Formation digitale blended avec e-learning et sessions présentielles interactives",
      results: ["95% adoption outils", "Efficacité opérationnelle +45%", "Satisfaction client +30%"],
      icon: "Building"
    },
    {
      client: "Organisation Internationale",
      sector: "Développement",
      challenge: "Renforcement des capacités de 50 chefs de projets sur la gestion de programmes complexes",
      solution: "Certification en gestion de projets avec simulations réelles et mentorat expert",
      results: ["100% certification", "Taux succès projets +50%", "Délais respectés 90%"],
      icon: "Globe"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Section 1: Hero/Introduction */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="GraduationCap" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Excellence en Formation
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Formation & Développement
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold" style={{ color: '#9B8E57' }}>
                Accélérez la Performance Humaine
              </p>
              
              <p className="text-lg text-gray-300 leading-relaxed">
                Transformez vos équipes en véritables forces de performance. Le Cabinet CRF Perfection 
                conçoit des programmes de formation sur mesure qui développent les compétences, renforcent 
                le leadership et maximisent le potentiel de vos collaborateurs pour un impact durable.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Demander une Formation
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <Link 
                  to="/service-request-form"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{ 
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Nos Programmes
                  <Icon name="BookOpen" size={20} className="ml-2" />
                </Link>
              </div>
            </div>

            {/* Right Content - Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Users" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">10K+</div>
                <div className="text-gray-300 text-sm">Professionnels Formés</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Award" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">95%</div>
                <div className="text-gray-300 text-sm">Taux de Satisfaction</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="TrendingUp" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">+35%</div>
                <div className="text-gray-300 text-sm">Gain Productivité</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Target" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">200+</div>
                <div className="text-gray-300 text-sm">Programmes Déployés</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Training Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nos Programmes de Formation
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des solutions complètes pour développer les compétences et maximiser le potentiel de vos équipes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {trainingServices?.map((service, index) => (
              <div 
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = index % 2 === 0 ? '#96121D' : '#9B8E57';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div 
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                    style={{ 
                      backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                    }}
                  >
                    <Icon 
                      name={service?.icon} 
                      size={32} 
                      style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {service?.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  {service?.features?.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <Icon 
                        name="CheckCircle" 
                        size={20} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                      />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Key Benefits & Success Stories */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Pourquoi Choisir Nos Formations ?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des avantages concrets pour maximiser l'impact de vos investissements en formation
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {keyBenefits?.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 text-center transition-all duration-300 hover:shadow-xl"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div 
                  className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{ 
                    backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                  }}
                >
                  <Icon 
                    name={benefit?.icon} 
                    size={36} 
                    style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            ))}
          </div>

          {/* Methodology & Success Stories Section */}
          <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Notre Approche Pédagogique
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Une méthodologie éprouvée combinant apprentissage interactif, pratique terrain et 
                  accompagnement personnalisé pour garantir l'application concrète des compétences acquises.
                </p>
                <div className="flex items-start space-x-3 mb-4">
                  <Icon name="CheckCircle" size={24} style={{ color: '#96121D' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Formation Pratique</h4>
                    <p className="text-gray-600">70% pratique avec mises en situation réelles et simulations</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Icon name="CheckCircle" size={24} style={{ color: '#9B8E57' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Suivi Post-Formation</h4>
                    <p className="text-gray-600">Coaching individuel et accompagnement prolongé pour pérenniser les acquis</p>
                  </div>
                </div>
              </div>

              <div 
                className="rounded-2xl p-8 text-white"
                style={{ 
                  background: 'linear-gradient(135deg, #96121D 0%, #7d0f18 100%)'
                }}
              >
                <h3 className="text-2xl font-bold mb-4">Transformations Réussies</h3>
                <div className="space-y-4">
                  {successStories?.slice(0, 3)?.map((story, idx) => (
                    <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                      <div className="flex items-center space-x-3 mb-2">
                        <Icon name={story?.icon} size={20} />
                        <h4 className="font-semibold">{story?.client}</h4>
                      </div>
                      <p className="text-sm text-gray-200">
                        {story?.results?.[0]}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Investissez dans le Capital Humain
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Transformez vos équipes dès aujourd'hui avec des formations qui génèrent un ROI mesurable
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Phone" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Diagnostic Gratuit</h3>
              <p className="text-gray-300 mb-4">Évaluons vos besoins en formation</p>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Prendre rendez-vous <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="BookOpen" size={32} className="mx-auto mb-4" style={{ color: '#96121D' }} />
              <h3 className="text-xl font-bold mb-2">Catalogue Formations</h3>
              <p className="text-gray-300 mb-4">Découvrez tous nos programmes</p>
              <Link 
                to="/service-request-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#96121D' }}
              >
                Voir le catalogue <Icon name="Download" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Mail" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Devis Sur Mesure</h3>
              <p className="text-gray-300 mb-4">Programme adapté à vos besoins</p>
              <Link 
                to="/information-request-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Demander un devis <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="text-center">
            <Link 
              to="/contact"
              className="inline-flex items-center justify-center px-12 py-5 text-xl font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl"
              style={{ 
                backgroundColor: '#96121D',
                boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#7d0f18';
                e.target.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#96121D';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Lancer Mon Programme
              <Icon name="ArrowRight" size={24} className="ml-3" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TrainingDevelopmentServicesPage;